import React from 'react';
import ADrawer from 'antd-mobile/lib/drawer';



export default class Drawer extends ADrawer {}